module.exports = __webpack_public_path__ + "img/girl_2.94d70f1c.svg";